"use client";

import { useEffect, useRef, useState } from "react";

import { initMockServiceWorker } from "@/mocks";

export default function MSWProviders({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false);
  const initialized = useRef(false);

  useEffect(() => {
    async function setup() {
      if (process.env.NODE_ENV === "development" && !initialized.current) {
        initialized.current = true;
        await initMockServiceWorker();
      }
      setReady(true); // MSW 초기화 후 렌더링 허용
    }

    setup();
  }, []);

  if (!ready) return null;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
